import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { Mixins } from 'web-common/src/shared/styles';

export type TextProps = {
  /** Light theme (White background) */
  light?: boolean;
};

/**
 * @deprecated The shef-web design system is being retired. Use `components/Input`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340209270973
 */
export const Text = styled.input.attrs(() => ({
  type: 'text',
}))<TextProps>`
  ${ifProp('light', Mixins.Input.TextLightStyles, Mixins.Input.TextStyles)}
`;

export const Number = styled.input.attrs(() => ({
  type: 'number',
}))<TextProps>`
  ${ifProp('light', Mixins.Input.TextLightStyles, Mixins.Input.TextStyles)}
`;

export const Date = styled.input.attrs(() => ({
  type: 'date',
}))<TextProps>`
  ${ifProp('light', Mixins.Input.TextLightStyles, Mixins.Input.TextStyles)}
`;
